import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';


const DetailedAnalyticsCard = ({ 
  weeklyData = [],
  monthlyTrends = {},
  bestPerformingArea = 'Faith',
  improvementSuggestions = []
}) => {
  const [activeTab, setActiveTab] = useState('weekly');

  const tabs = [
    { id: 'weekly', label: 'Weekly', icon: 'Calendar' },
    { id: 'trends', label: 'Trends', icon: 'TrendingUp' },
    { id: 'insights', label: 'Insights', icon: 'Lightbulb' }
  ];

  const renderWeeklyView = () => (
    <div className="space-y-4">
      <h4 className="font-heading font-semibold text-foreground mb-3">
        Last 7 Days Performance
      </h4>
      <div className="space-y-3">
        {weeklyData?.map((day, index) => (
          <div key={index} className="flex items-center justify-between py-2">
            <div className="flex items-center space-x-3">
              <div className="text-sm font-medium text-foreground min-w-[60px]">
                {day?.date}
              </div>
              <div className="flex space-x-1">
                {['Faith', 'Family', 'Finances', 'Fitness']?.map((area) => (
                  <div
                    key={area}
                    className={`w-3 h-3 rounded-full ${
                      day?.completed?.[area] 
                        ? 'bg-success' :'bg-muted border border-border'
                    }`}
                    title={`${area}: ${day?.completed?.[area] ? 'Completed' : 'Not completed'}`}
                  />
                ))}
              </div>
            </div>
            <div className="text-sm text-muted-foreground">
              {Object.values(day?.completed)?.filter(Boolean)?.length}/4
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderTrendsView = () => (
    <div className="space-y-4">
      <h4 className="font-heading font-semibold text-foreground mb-3">
        Monthly Trends
      </h4>
      <div className="grid grid-cols-2 gap-4">
        {Object.entries(monthlyTrends)?.map(([area, data]) => (
          <div key={area} className="p-3 bg-muted/50 rounded-lg">
            <div className="text-sm font-medium text-foreground mb-1">
              {area}
            </div>
            <div className="flex items-center space-x-2">
              <span className="text-lg font-bold text-foreground">
                {data?.average?.toFixed(1)}%
              </span>
              <div className={`flex items-center text-xs ${
                data?.trend > 0 ? 'text-success' : data?.trend < 0 ? 'text-error' : 'text-muted-foreground'
              }`}>
                <Icon 
                  name={data?.trend > 0 ? 'TrendingUp' : data?.trend < 0 ? 'TrendingDown' : 'Minus'} 
                  size={12} 
                />
                <span className="ml-1">
                  {Math.abs(data?.trend)?.toFixed(1)}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  const renderInsightsView = () => (
    <div className="space-y-4">
      <h4 className="font-heading font-semibold text-foreground mb-3">
        Personal Insights
      </h4>
      
      {/* Best Performing Area */}
      <div className="p-3 bg-success/10 border border-success/20 rounded-lg">
        <div className="flex items-center space-x-2 mb-2">
          <Icon name="Trophy" size={16} className="text-success" />
          <span className="text-sm font-medium text-success">
            Top Performing Area
          </span>
        </div>
        <p className="text-sm text-foreground">
          <strong>{bestPerformingArea}</strong> is your strongest area with consistent completion rates.
        </p>
      </div>

      {/* Improvement Suggestions */}
      <div className="space-y-2">
        <h5 className="text-sm font-medium text-foreground">
          Suggestions for Growth
        </h5>
        {improvementSuggestions?.map((suggestion, index) => (
          <div key={index} className="flex items-start space-x-2 p-2 bg-muted/30 rounded">
            <Icon name="ArrowRight" size={14} className="text-primary mt-0.5 flex-shrink-0" />
            <span className="text-sm text-foreground">{suggestion}</span>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="bg-card border border-border rounded-lg shadow-gentle">
      {/* Tab Navigation */}
      <div className="border-b border-border">
        <div className="flex">
          {tabs?.map((tab) => (
            <button
              key={tab?.id}
              onClick={() => setActiveTab(tab?.id)}
              className={`flex items-center space-x-2 px-4 py-3 text-sm font-medium transition-colors duration-200 ${
                activeTab === tab?.id
                  ? 'text-primary border-b-2 border-primary bg-primary/5' :'text-muted-foreground hover:text-foreground hover:bg-muted/50'
              }`}
            >
              <Icon name={tab?.icon} size={16} />
              <span>{tab?.label}</span>
            </button>
          ))}
        </div>
      </div>
      {/* Tab Content */}
      <div className="p-4">
        {activeTab === 'weekly' && renderWeeklyView()}
        {activeTab === 'trends' && renderTrendsView()}
        {activeTab === 'insights' && renderInsightsView()}
      </div>
    </div>
  );
};

export default DetailedAnalyticsCard;